import { useForm } from "react-hook-form";
import ControlledInput from "Components/Input";
import { useTranslation } from "react-i18next";
import Button from "Components/Button";
import Space from "Components/Space";
import FlexRow from "Components/FlexRow";
import { useEffect } from "react";
import {IFoilTypeDto, IPrintPlacementDto} from "Apis/Models/IPrintDto";
import {useMutateFoilType} from "../../../Apis/FoilTypeApi";

interface IProps {
    foilType?: IFoilTypeDto;
    onSubmit?: (data: IPrintPlacementDto) => void;
}
const FoilTypeForm = (props: IProps) => {
    
    const { t } = useTranslation();
    
    const { control, handleSubmit, reset } = useForm<IFoilTypeDto>()
    const { mutateAsync, isLoading } = useMutateFoilType();
    
    useEffect(() => {
        if (props.foilType) {
            reset(props.foilType);
        }
    }, [reset, props.foilType])
    
    const onSubmit = async(data: IFoilTypeDto) => {
        await mutateAsync(data);
        
        if (props.onSubmit) {
            props.onSubmit(data);
        }
        
        reset();
    }
    
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Space direction={"vertical"} size={"large"}>
                <ControlledInput rules={{required: true}} name={"name"} control={control} placeholder={t('name')} />
                
                <FlexRow justify={"end"}>
                    <Button buttonType={"submit"} type={"primary"} text={t('save')} loading={isLoading} />
                </FlexRow>
            </Space>
        </form>
    )
}

export default FoilTypeForm
